import { render, staticRenderFns } from "./BlackList.vue?vue&type=template&id=4ad32292&scoped=true&"
import script from "./BlackList.vue?vue&type=script&lang=js&"
export * from "./BlackList.vue?vue&type=script&lang=js&"
import style0 from "./BlackList.vue?vue&type=style&index=0&id=4ad32292&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad32292",
  null
  
)

export default component.exports